/*
*
* Script for gallery
* need to work : https://photoswipe.com
*/

import PhotoSwipeLightbox from 'photoswipe/lightbox';

export const lightBoxInit = () => {

    const figures = document.querySelectorAll('figure.lightbox');
    if (figures) {
        figures.forEach(figure => {
            let lightbox = new PhotoSwipeLightbox({
                gallery: figure,
                children: 'a',
                pswpModule: () => import('photoswipe')
            });

            lightbox.init();
        });
    }

    const galleries = document.querySelectorAll('.bn-gallery-js');
    if (galleries) {
        galleries.forEach(gallery => {
            let lightbox = new PhotoSwipeLightbox({
                gallery: gallery,
                children: 'a',
                pswpModule: () => import('photoswipe')
            });

            lightbox.init();
        });
    }
}